import { ActivatedRoute, Router } from "@angular/router";
import { SessionService } from "@services/session.service";
import AccionesFuncionalidad from "@shared/enums/acciones.enum";
import Funcionalidades from "@shared/enums/funcionalidades.enum";
import { Usuario } from "@models/usuario.model";
import { Location } from "@angular/common";
import { StateService } from "@services/state.service";
import IEstadoDatatable from "@models/datatable.interface";
import ExpedienteEstados from "@shared/enums/expediente-estados.enum";
import { TipoDocumento } from "@models/tipo-documento.model";
import { Archivo } from "@models/archivo.model";
import { Subscription } from 'rxjs'
import { Directive } from "@angular/core";

@Directive()
export abstract class BaseFuncionalidadComponent {
    idFuncionalidad: number; // Variable que almacena la funcionalidad desde el router
    idAccion: number; // Variable que almacena la acción recibida desde el router
    
    name: string; // Variable que almacena el nombre de la acción actual
    help: string; // Variable que almacena el texto de ayuda de la acción actual

    private subFuncionalidad: Subscription; // Variable que maneja el permiso de la funcionalidad
    canSearch: boolean = false; // Variable que maneja el permiso para buscar prestador
    canCleanData: boolean = false; // Variable que maneja el permiso para limpiar datos
    canCreate: boolean = false; // Variable que maneja el permiso para crear expediente
    canRead: boolean = false; // Variable que maneja el permiso para ver expediente
    canApprove: boolean = false; // Variable que maneja el permiso para aprobar expediente
    canReject: boolean = false; // Variable que maneja el permiso para rechazar expediente
    canRequestExtend: boolean = false; // Variable que maneja el permiso para solicitar prórroga
    canReadExtend: boolean = false; // Variable que maneja el permiso para ver una prórroga
    canApproveExtend: boolean = false; // Variable que maneja el permiso para aprobar una prórroga
    canRejectExtend: boolean = false; // Variable que maneja el permiso para rechazar una prórroga
    canReadDoc: boolean = false; // Variable que maneja el permiso para ver los antecedentes ingresador por el prestador
    canAddDoc: boolean = false; // Variable que maneja el permiso para ingresar antecedentes
    canSendDoc: boolean = false; // Variable que maneja el permiso para enviar los antecedentes
    canReplaceDoc: boolean = false; // Variable que maneja el permiso para enviar los antecedentes
    canReadHistory: boolean = false; // Variable que maneja el permiso para ver el historial de expedientes
    canSignSanction: boolean = false; // Variable que maneja el permiso firmar la resolución de la sanción
    canCloseExpedient: boolean = false; // Variable que maneja el permiso para cerrar el expediente
    canReadApelation: boolean = false; // Variable que maneja el permiso para ver una apelación
    canMakeApelation: boolean = false; // Variable que maneja el permiso para ver una apelación
    canApproveApelation: boolean = false; // Variable que maneja el permiso para aprobar una apelación
    canRejectApelation: boolean = false; // Variable que maneja el permiso para rechazar una apelación
    canReadTemplate: boolean = false; // Variable que maneja el permiso para ver las plantillas de documentos;


    nameAction: Function; // Funcion que sera llamada desde el component html para mostrar el nombre de la acción
    helpAction: Function; // Funcion que sera llamada desde el component html para mostrar la ayuda de la acción

    titulo: string; // Variable que muestra el titulo de la página obteniendola desde la funcionalidad

    usuario: Usuario; // Variable que maneja los datos del usuario que inicio sesion

    isProveedorFuncionality: boolean = false; // Variable que maneja el renderizado de información que solo se le muestra al proveedor
    isFirmarResolucion: boolean = false; // Variable que maneja el renderizado de información que solo se muestra al firmar la resolución
    isRevisarAntecedentes: boolean = false; // Variable que maneja el renderizado de información que solo se muestra en la funcionalidad de revisar antecedentes
    isVerPlantillasDocumentos: boolean = false; // Variable que maneja el renderizado de información que solo se muestra en la funcionalidad de ver plantillas de documentos

    isLoading: boolean = false; // Variable que maneja el renderizado del spinner de carga de la tabla licencias medicas

    AccionesFuncionalidadEnum = AccionesFuncionalidad; // Variable con las acciones para ser utilizada en el component html

    // Variable que maneja la pagina, cuadro de búsqueda y orden con el que se inicializa el datatable
    estadoDatatableExpediente: IEstadoDatatable;
    estadoDatatableLicencia: IEstadoDatatable;

    //fechaExpirada: boolean = true; // Variable para saber si ya expiro el plazo del prestador para enviar los antecedentes
    prorrogaSolicitada: boolean = false; // Variable que maneja el renderizado de la columna acción de la tabla
    verSancion: boolean = false; // Variable que maneja el renderizado de la sanción en el header del expediente

    id: number; // ID del expediente
    tipoDocumento: TipoDocumento; // Variable que guarda la información del tipo de documento que se va a ingresar
    documento: Archivo; // Variable que guarda la información del documento que se va a mostrar

    isLoadingModal = false; // Variable que maneja el spinner de carga del boton del modal
    mostrarModalConfirmacion = false; // Variable que maneja el renderizado del modal de confirmación de la acción

    constructor(
        protected route: ActivatedRoute,
        protected sessionService: SessionService,
        protected location: Location,
        protected router: Router,
        protected stateService: StateService
    ) {
        // Obtener funcionalidad desde el router
        this.idFuncionalidad = this.route.snapshot.data["funcionalidad"];
        // Obtener acción desde el router
        this.idAccion = this.route.snapshot.data["accion"];

        // Obtener el usuario que inicio sesión
        this.usuario = this.sessionService.getSesionActual();

        // Verifica si es una funcionalidad del prestador
        this.isProveedorFuncionality = this.idFuncionalidad === Funcionalidades.revisar_solicitudes;
        // Verifica si es la funcionalidad de firmar resolución
        this.isFirmarResolucion = this.idFuncionalidad === Funcionalidades.revisar_resoluciones_a_firmar;
        // Verifica si es la funcionalidad de revisar antecedentes
        this.isRevisarAntecedentes = this.idFuncionalidad === Funcionalidades.revisar_antecedentes;

        // Verifica si es la funcionalidad de revisar plantillas de documentos
        this.isVerPlantillasDocumentos = this.idFuncionalidad === Funcionalidades.ver_plantillas;

        // Verificar permisos de acción
        this.obtenerPermisosAccion();

        // Función para obtener el nombre de la acción
        this.nameAction = (accion: number) => {
            return this.sessionService.getAction(this.idFuncionalidad, accion)?.nombre_acc;
        };
        // Función para obtener el texto de ayuda de la acción
        this.helpAction = (accion: number) => {
            return this.sessionService.getAction(this.idFuncionalidad, accion)?.ayuda_acc;
        };

        // Obtener los datos de la funcionalidad actual
        const funcionalidad = this.sessionService.getFunctionality(
            this.idFuncionalidad
        );

        // Obtener los datos de la acción actual
        const accion = this.sessionService.getAction(
            this.idFuncionalidad, this.idAccion
        );
        // Nombre de la funcionalidad
        this.titulo = accion?.nombre_acc??funcionalidad?.nombre_fnc;
        // obtener states desde el service state
        this.obtenerStates();
        // Obtener parametros get
        this.route.paramMap.subscribe((params) => {
            const idParam = params.get("id");
            if (idParam) this.id = Number(idParam);
        });
        // Obtener datos de la acción actual
        this.obtenerDatosAccionActual();
        // Verificar si se a solicitado una prórroga
        // this.prorrogaSolicitada = [ExpedienteEstados.solicitud_prorroga, ExpedienteEstados.prorroga_aprobada, ExpedienteEstados.prorroga_rechazada].includes(this.expediente?.estado.codigo);
        this.verSancion = [Funcionalidades.revisar_apelaciones, Funcionalidades.revisar_resoluciones_a_firmar].includes(this.idFuncionalidad);
        this.stateService.getContraste(); // Cargar contraste de la página
        this.stateService.getFontSize(); // Cargar tamaño de fuente de la página
    }

    private obtenerStates() {
        // Obtener State Prestador
        // if (this.isProveedorFuncionality) this.prestador = this.stateService.getPrestador();
        // // Obtener State Expediente
        // this.expediente = this.stateService.getExpediente();
        // // Obtener State Licencia
        // this.licencia = this.stateService.getLicencia();
        // Obtener State Tipo Documento
        this.tipoDocumento = this.stateService.getTipoDocumento();
        // Obtener State Documento
        this.documento = this.stateService.getDocumento();
        // Obtener State Datatable Expedientes
        this.estadoDatatableExpediente = this.stateService.getEstadoDatatableExpediente();
        // Obtener State Datatable Licencias
        this.estadoDatatableLicencia = this.stateService.getEstadoDatatableLicencia();

        this.subFuncionalidad = this.sessionService
            .hasFunctionality$(this.idFuncionalidad)
            .subscribe(hasFunc => {
                if (!hasFunc && !this.router.url.startsWith('/inicio')) {
                    const home = this.sessionService.getSesionActual()?.rolSeleccionado;
                    this.router.navigate([home ? '/unauthorized' : "/"]);
                }
            });
    }

    private obtenerDatosAccionActual() {
        // Obtener nombre de la acción
        this.name = this.sessionService.getAction(
            this.idFuncionalidad,
            this.idAccion
        )?.nombre_acc;
        // Obtener la descripción de ayuda de la acción
        this.help = this.sessionService.getAction(
            this.idFuncionalidad,
            this.idAccion
        )?.ayuda_acc;
    }

    private obtenerPermisosAccion() {
        this.canSearch = this.sessionService.hasAction(
            this.idFuncionalidad,
            AccionesFuncionalidad.buscar_solicitudes
        );
        this.canCleanData = this.sessionService.hasAction(
            this.idFuncionalidad,
            AccionesFuncionalidad.limpiar_datos
        );
        this.canCreate = this.sessionService.hasAction(
            this.idFuncionalidad,
            AccionesFuncionalidad.crear_expediente
        );
        this.canRead = this.sessionService.hasAction(
            this.idFuncionalidad,
            AccionesFuncionalidad.ver_expediente
        );
        this.canApprove = this.sessionService.hasAction(
            this.idFuncionalidad,
            AccionesFuncionalidad.aprobar_expediente
        );
        this.canReject = this.sessionService.hasAction(
            this.idFuncionalidad,
            AccionesFuncionalidad.rechazar_expediente
        );
        this.canRequestExtend = this.sessionService.hasAction(
            this.idFuncionalidad,
            AccionesFuncionalidad.solicitar_prorroga
        );
        this.canReadExtend = this.sessionService.hasAction(
            this.idFuncionalidad,
            AccionesFuncionalidad.ver_prorroga
        );
        this.canApproveExtend = this.sessionService.hasAction(
            this.idFuncionalidad,
            AccionesFuncionalidad.aprobar_prorroga
        );
        this.canRejectExtend = this.sessionService.hasAction(
            this.idFuncionalidad,
            AccionesFuncionalidad.rechazar_prorroga
        );
        this.canReadDoc = this.sessionService.hasAction(
            this.idFuncionalidad,
            AccionesFuncionalidad.ver_antecedentes
        );
        this.canAddDoc = this.sessionService.hasAction(
            this.idFuncionalidad,
            AccionesFuncionalidad.ingresar_antecedentes
        );
        this.canSendDoc = this.sessionService.hasAction(
            this.idFuncionalidad,
            AccionesFuncionalidad.enviar_antecedentes
        );
        this.canReplaceDoc = this.sessionService.hasAction(
            this.idFuncionalidad,
            AccionesFuncionalidad.reemplazar_documento
        );
        this.canReadHistory = this.sessionService.hasAction(
            this.idFuncionalidad,
            AccionesFuncionalidad.ver_historial
        );
        this.canSignSanction = this.sessionService.hasAction(
            this.idFuncionalidad,
            AccionesFuncionalidad.firmar_resolucion
        );
        this.canCloseExpedient = this.sessionService.hasAction(
            this.idFuncionalidad,
            AccionesFuncionalidad.cerrar_expediente
        );
        this.canMakeApelation = this.sessionService.hasAction(
            this.idFuncionalidad,
            AccionesFuncionalidad.solicitar_apelacion
        );
        this.canReadApelation = this.sessionService.hasAction(
            this.idFuncionalidad,
            AccionesFuncionalidad.ver_apelacion
        );
        this.canApproveApelation = this.sessionService.hasAction(
            this.idFuncionalidad,
            AccionesFuncionalidad.aprobar_apelacion
        );
        this.canRejectApelation = this.sessionService.hasAction(
            this.idFuncionalidad,
            AccionesFuncionalidad.rechazar_apelacion
        );
        this.canReadTemplate = this.sessionService.hasAction(
            this.idFuncionalidad,
            AccionesFuncionalidad.ver_plantillas_documentos
        );
    }
    
    ngOnDestroy(): void {
        this.subFuncionalidad?.unsubscribe();
    }

    protected volverAtras() {
        this.location.back();
    }

    protected volverDosPaginasAtras() {
        window.history.go(-2);
    }



    // Verificar que tenga permisos para ver esta funcionalidad
    protected get hasFunctionality(): boolean {
        return this.sessionService.hasFunctionality(
            this.idFuncionalidad
        );
    }
}
